import { Component, OnInit, Input } from '@angular/core';
import { Announcement } from '../shared/models/announcement-model';
import { AnnouncementExtendedLocationViewModel, AnnouncementFrameTypeEnum, BrandingAnnouncementTileTypeEnum, UserTypeEnum } from '@hrra/common-models';
import { AnnouncementListingSectionEnum } from '@hrra/common-models';
import { ApplicationMethodEnum } from '@hrra/common-models';
import { PageNameEnum } from 'src/app/shared/models/enums/page-names-enum';
import { select, Store } from '@ngrx/store';
import { AppState } from 'src/app/root-store/state';
import { addToFavorites, removeFromFavorites } from 'src/app/root-store/actions';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { selectTimeZone } from 'src/app/root-store/selectors';
import { AnnouncementBaubleTypeEnum } from '@hrra/common-models';

@Component({
    selector: 'app-announcement-item',
    // templateUrl: `./${theme.name}/announcement-item.component.html`,
    // styleUrls: [`./${theme.name}/announcement-item.component.scss`],
    templateUrl: `./redesign/announcement-item.component.html`,
    styleUrls: [`./redesign/announcement-item.component.scss`],
    standalone: false
})
export class AnnouncementItemComponent implements OnInit {
  companyHasCvBox = true;

  @Input() announcement: Announcement;
  @Input() pageName: PageNameEnum;
  @Input() date: Date;
  @Input() providerWebsiteUrlMap: { [index: number]: string };
  @Input() userType: any;

  @Input() providerWebsiteId: number

  public page: any;
  public announcementFrameType: any;
  public announcementBaubleType: any;
  public announcementType: any;
  public applicationMethodType: any;
  public brandingAnnouncementTileType: any;

  timeZone$: Observable<string>;
  announcementListSectionMap: { [index: number]: string };

  userTypeEnum: any;

  constructor(private store: Store<AppState>, private translate: TranslateService) {
    this.announcementFrameType = AnnouncementFrameTypeEnum;
    this.announcementBaubleType = AnnouncementBaubleTypeEnum;
    this.announcementType = AnnouncementListingSectionEnum;
    this.applicationMethodType = ApplicationMethodEnum;
    this.brandingAnnouncementTileType = BrandingAnnouncementTileTypeEnum;
    this.page = PageNameEnum;

    this.userTypeEnum = UserTypeEnum;

    this.announcementListSectionMap = {
      [AnnouncementListingSectionEnum.VipCV]: 'label.VipCv',
      [AnnouncementListingSectionEnum.Vip]: 'label.Vip',
      [AnnouncementListingSectionEnum.Exclusive]: 'label.Exclusive',
      [AnnouncementListingSectionEnum.P2]: 'label.PrioStandard',
      [AnnouncementListingSectionEnum.P1]: 'label.PrioStart'
    };
  }

  ngOnInit(): void {
    this.timeZone$ = this.store.pipe(select(selectTimeZone));
  }

  get currentLang(): string {
    return this.translate.currentLang;
  }

  get isBrandedWithSpecialDesign(): boolean {
    return this.announcement?.isWithBranding
      && this.announcement.brandingAnnouncementTileTypeId === BrandingAnnouncementTileTypeEnum.TileWithSpecialDesign;
  }

  get isBrandedWithRibbon(): boolean {
    return this.announcement?.isWithBranding
      && this.announcement.brandingAnnouncementTileTypeId === BrandingAnnouncementTileTypeEnum.TileWithRibbon;
  }

  get isFramedWithFlame(): boolean {
    return this.announcement?.isWithFrame && this.announcement.frameType === AnnouncementFrameTypeEnum.FrameFlame;
  }

  get isFramedWithPlus(): boolean {
    return this.announcement?.isWithFrame && this.announcement.frameType === AnnouncementFrameTypeEnum.FramePlus;
  }

  get titleDecorationSrc(): string {
    if (this.announcement?.isWithBauble) {
      return `assets/icons/decorations/${this.announcementBaubleType[this.announcement.baubleType]}.png`;
    }

    if (this.isFramedWithFlame || this.isFramedWithPlus) {
      return `assets/icons/${this.announcementFrameType[this.announcement.frameType]}.svg`;
    }

    return null;
  }

  get isAppliedViaWebsite(): boolean {
    return this.announcement?.applicationMethod === ApplicationMethodEnum.ViaWebsite
      && this.userType !== UserTypeEnum.Internal;
  }

  get isAppliedViaExternalUrl(): boolean {
    return this.announcement?.applicationMethod === ApplicationMethodEnum.RedirectToUrl
      && this.userType !== UserTypeEnum.Internal;
  }

  get isInvitedJobseeker(): boolean {
    return this.userType === UserTypeEnum.Jobseeker && this.announcement?.isInvited;
  }

  public locationName(location: AnnouncementExtendedLocationViewModel): string {
    return (location?.announcementExtendedLocationParts ?? []).map(part => part.name).join(', ');
  }

  onToggleFavorite() {
    let announcementId = this.announcement.announcementId;
    if (this.announcement.isFavorite) {
      this.store.dispatch(removeFromFavorites({ payload: { announcementId: announcementId } }));
    }
    else {
      this.store.dispatch(addToFavorites({ payload: { announcementId: announcementId } }))
    }
  }

  public isPublishedToday(): boolean {

    let rawActualPublishDate = this.announcement.renewalDate || this.announcement.publishDate;
    let actualPublishDate = new Date(rawActualPublishDate);

    let currentDate = this.date;

    let publishDateKey = this.getDateKey(actualPublishDate);
    let currentDateKey = this.getDateKey(currentDate);

    return publishDateKey == currentDateKey;

  }

  public isDeadLineToday(): boolean {
    let annDeadlineDate = new Date(this.announcement.deadlineDate);
    let currentDate = this.date;

    let deadlineDateKey = this.getDateKey(annDeadlineDate)
    let currentDateKey = this.getDateKey(currentDate);

    return deadlineDateKey == currentDateKey;
  }

  public getDateKey(date: Date): string {
    return date.getDay() + "/" + date.getMonth() + "/" + date.getFullYear();
  }
}
